



























































































































































































































import { Component, Vue } from "vue-property-decorator";
import { getUpdateLog } from "@/req/homes";
import { data } from "./uploadConfig";
@Component({
  components: {},
})
export default class Home extends Vue {
  public dataList: any = data;
  public dataLists = [];
  public strLimit = -1;
  public limit = -1;
  public limits = -1;
  public str = "";

  public dataModel = []; // 接口请求
  public changeShow = false;
  public activeShow: any = null;
  public activeShowC: any = null;
  public activeShowCIndex: any = null;
  public showContent = {};
  public contentShow = false;

  public oneShow = false;
  public twoShow = false;
  public contentList: any = {};
  public searchList: any = [];
  public timeout: any = null;
  public created() {
    this.getLogList();
  }
  public async getLogList() {
    const res = await getUpdateLog({});
    if (res.code == 200) {
      const arr: any = [];
      if (res.data) {
        res.data.forEach((item) => {
          arr.push(item);
        });
      }
      this.dataModel = arr.filter(item => {
        return item.name !== "996传奇引擎Lua版-更新日志"
      });
    }
  }

  public handleSelectTitle(index) {
    this.contentShow = false;
    this.activeShowCIndex = null;
    if (this.activeShow == index) {
      this.activeShow = null;
    } else {
      this.activeShow = index;
    }
  }
  public dealTimer(d) {
    const now = new Date(d * 1000);
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const date = now.getDate();
    const hour = now.getHours();
    const minute = now.getMinutes();
    const second = now.getSeconds();
    return (
      year + "-" + month + "-" + date
    );
  }
  public handleSelectChild(row, idx, index) {
    const content = JSON.parse(JSON.stringify(row));
    row.created_time = this.dealTimer(content.create_time);
    this.showContent = row;
    this.contentShow = true;
    this.activeShowCIndex = index + "-" + idx;
    const contentDesc: any = this.$refs.contentDesc;
    contentDesc.scrollTop = 0;
    this.changeShow = false;
  }
  public strChange() {
    this.strLimit = -1;
    this.str = this.str.replace(/\s+/g, "");
    this.searchList = [];
    if (this.str) {
      this.debounce(this.getArrayByName, 500);
    } else {
      this.changeShow = false;
    }
  }
  public debounce(func, wait) {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      func();
    }, wait);
  }
  public getArrayByName() {
    const arrnew: any = [];
    this.dataModel.forEach((item: any, index) => {
      item.list.forEach((its, idx) => {
        its.index = index;
        its.childIndex = idx;
        arrnew.push(its);
      });
    });
    const newData = arrnew.filter((item) => {
      if (item.title.indexOf(this.str) > -1) {
        // indexOf方法中如果xxx.indexOf("")返回值为0
        return item;
      }
      return newData;
    });
    this.searchList = newData;
    if (newData.length == 0) {
      this.changeShow = false;
      return false;
    }
    this.changeShow = true;
  }
  public close() {
    if (this.str != "") {
      this.strLimit = -1;
      this.str = "";
      this.changeShow = false;
      if (this.limit != -1 || this.limits != -1) {
        this.contentShow = false;
      } else {
        this.contentShow = true;
      }
    }
  }
  public query() {
    this.strLimit = -1;
    this.searchList = [];
    if (this.str) {
      this.debounce(this.getArrayByName, 500);
    }
  }
  public listTab(state, datas, shows) {
    state == 1
      ? (this.oneShow = !this.oneShow)
      : (this.twoShow = !this.twoShow);
    const nextElement: any = this.$refs.listOne;
    const nextElements: any = this.$refs.listTwo;
    if (this.oneShow && this.twoShow) {
      const targetHeight = window.getComputedStyle(nextElement).height;
      const targetHeights = window.getComputedStyle(nextElements).height;
      setTimeout(() => {
        nextElement.style.height = "calc(50% - 80px)";
        nextElements.style.height = "calc(50% - 80px)";
      }, 20);
    } else if (this.oneShow && !this.twoShow) {
      nextElements.style.height = "0px";
      const targetHeight = window.getComputedStyle(nextElement).height;
      const targetHeights = window.getComputedStyle(nextElements).height;
      nextElement.style.height = "0px";
      setTimeout(() => {
        nextElement.style.height = "calc(100% - 154px)";
      }, 20);
      if (!this.oneShow) this.limit = -1;
      if (!this.twoShow) this.limits = -1;
      if (this.limit != -1) {
        this.contentShow = false;
      } else {
        this.contentShow = true;
      }
      nextElement.style.height = "0px";
      nextElements.style.height = "0px";
    } else if (!this.oneShow && this.twoShow) {
      nextElement.style.height = "0px";
      nextElements.style.height = "auto";
      const targetHeight = window.getComputedStyle(nextElement).height;
      const targetHeights = window.getComputedStyle(nextElements).height;
      nextElements.style.height = "0px";
      setTimeout(() => {
        nextElements.style.height = "calc(100% - 154px)";
      }, 20);
      if (!this.oneShow) this.limit = -1;
      if (!this.twoShow) this.limits = -1;
      if (this.limit != -1) {
        this.contentShow = false;
      } else {
        this.contentShow = true;
      }
      nextElement.style.height = "0px";
      nextElements.style.height = "0px";
    } else {
      if (!this.oneShow) this.limit = -1;
      if (!this.twoShow) this.limits = -1;
      if (this.limit != -1) {
        this.contentShow = false;
      } else {
        this.contentShow = true;
      }
      nextElement.style.height = "0px";
      nextElements.style.height = "0px";
    }
    if (this.limit == -1 && this.limits == -1) {
      if (state == 1) {
        if (this.oneShow) {
          this.activeShow = 1;
        }
        if (!this.oneShow && this.twoShow) {
          this.activeShow = 2;
        }
        if (!this.oneShow && !this.twoShow) {
          this.activeShow = 0;
        }
      }
      if (state == 2) {
        if (this.twoShow) {
          this.activeShow = 2;
        }
        if (!this.twoShow && this.oneShow) {
          this.activeShow = 1;
        }
        if (!this.twoShow && !this.oneShow) {
          this.activeShow = 0;
        }
      }
    }
  }
  public toOpen(state) {
    if (state == 1)
      window.open("https://bbs.996m2.com/forum-2-1.html", "_blank");
  }
  public openDetail(state, item, index) {
    this.contentShow = false;
    this.contentList = {};
    this.strLimit = -1;
    const contentDesc: any = this.$refs.contentDesc;
    contentDesc.scrollTop = 0;
    if (state == 1) {
      this.activeShow = 3;
      this.limits = -1;
      this.limit = index;
      this.contentList = item;
    }
    if (state == 2) {
      this.activeShow = 4;
      this.limits = index;
      this.limit = -1;
      this.contentList = item;
    }
  }
  public openStrDetail(item, index) {
    const listOne: any = this.$refs.listOne;
    listOne.scrollTop = 0;
    this.oneShow = false;
    this.twoShow = false;
    this.dataList.forEach((items, indexs) => {
      if (items.title == item.title) {
        this.contentShow = false;
        this.contentList = {};
        this.limits = -1;
        this.limit = indexs;
        this.strLimit = -1;
        this.contentList = items;
        const contentDesc: any = this.$refs.contentDesc;
        contentDesc.scrollTop = 0;
        const oneShow: any = this.$refs.oneShow;
        oneShow.click();
        this.changeShow = false;
        this.str = "";
        this.strLimit = -1;
        this.activeShow = 3;
        const className: any =
          document.getElementsByClassName("box_list_oneActive");
        setTimeout(() => {
          const classNameTop = className[0].getBoundingClientRect().top;
          const listOneTop = listOne.getBoundingClientRect().top;
          listOne.scrollTop = classNameTop - listOneTop;
        }, 500);
      }
    });
  }
}
